var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "shop_1_",
    "data-name": "shop (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.609,
    height: 23.233,
    viewBox: "0 0 26.609 23.233",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1508",
    "data-name": "Group 1508",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1001",
    "data-name": "Path 1001",
    d: "M253.61,263.75h-3.616a1.8,1.8,0,0,0-1.794,1.794v2.773a1.8,1.8,0,0,0,1.794,1.794h3.616a1.8,1.8,0,0,0,1.794-1.794v-2.773A1.8,1.8,0,0,0,253.61,263.75Zm.489,4.567a.491.491,0,0,1-.489.489h-3.616a.491.491,0,0,1-.489-.489v-2.773a.491.491,0,0,1,.489-.489h3.616a.491.491,0,0,1,.489.489Z",
    transform: "translate(-234.705 -251.098)",
    fill: "#44677b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1002",
    "data-name": "Path 1002",
    d: "M26.609,38.662a.606.606,0,0,0-.087-.321l-3.958-6.96A.656.656,0,0,0,22,31.05H4.605a.645.645,0,0,0-.565.332L.087,38.341A.66.66,0,0,0,0,38.662a3.817,3.817,0,0,0,2.284,3.491V53.63a.654.654,0,0,0,.652.652H23.668a.654.654,0,0,0,.652-.652v-11.4a.287.287,0,0,0-.005-.071A3.827,3.827,0,0,0,26.609,38.662ZM4.986,32.36H21.618L24.712,37.8H1.9ZM18.937,39.1A2.508,2.508,0,0,1,14,39.1Zm-6.323,0a2.511,2.511,0,0,1-4.942,0Zm-11.266,0H6.291a2.511,2.511,0,0,1-4.942,0Zm9.613,13.876H7.21V45.937a.929.929,0,0,1,.93-.93h1.9a.929.929,0,0,1,.93.93v7.041Zm12.054,0H12.266V45.937A2.238,2.238,0,0,0,10.031,43.7h-1.9A2.238,2.238,0,0,0,5.9,45.937v7.047H3.588V42.473c.076.005.152.005.228.005a3.812,3.812,0,0,0,3.164-1.686,3.813,3.813,0,0,0,6.329,0,3.8,3.8,0,0,0,6.318,0,3.812,3.812,0,0,0,3.164,1.686c.076,0,.147-.005.223-.005v10.5Zm-.223-11.8a2.506,2.506,0,0,1-2.468-2.066h4.942A2.522,2.522,0,0,1,22.792,41.174Z",
    transform: "translate(0 -31.05)",
    fill: "#44677b"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.8583327592366970edca5db034ac2250.svg";
export { ForwardRef as ReactComponent };